const LinksConstants = {
  BeckTechWebsite: 'http://www.beck-technology.com',
  BeckTechCommunityWebsite: 'http://community.beck-technology.com',
  EstimatorWebsite: 'https://beck-technology.com/destini-estimator',
};

export default LinksConstants;
